import { render, staticRenderFns } from "./ordersDetails.vue?vue&type=template&id=c88a90b0&scoped=true"
import script from "./ordersDetails.vue?vue&type=script&lang=js"
export * from "./ordersDetails.vue?vue&type=script&lang=js"
import style0 from "./ordersDetails.vue?vue&type=style&index=0&id=c88a90b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88a90b0",
  null
  
)

export default component.exports